import React from 'react';
import SEOHead from '../SEOHead';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import HowItWorksSection from './HowItWorksSection';
import DashboardPreview from './DashboardPreview';
import CTASection from './CTASection';
import FAQSection from './FAQSection';
import OurStorySection from './OurStorySection';
import Footer from '../Footer/Footer';
import Navigation from '../Navigation/Navigation';
import useImagePreloader from '../../hooks/useImagePreloader';

// Import critical images for preloading
import hqWallpaper from '../../assets/hq-wallpaper.webp';
import christReignsLogo from '../../assets/crm-newlogo.png';

const LandingPage: React.FC = () => {
  // Preload critical images for hero section
  useImagePreloader({
    images: [hqWallpaper, christReignsLogo],
    priority: true
  });

  return (
    <div className="min-h-screen">
      <SEOHead />
      <Navigation />
      
      {/* Hero Section */}
      <section id="hero">
        <HeroSection />
      </section>
      
      {/* How It Works */}
      <section id="how-it-works">
        <HowItWorksSection />
      </section>
      
      {/* Features */} 
      <section id="features">
        <FeaturesSection />
      </section>
      
      {/* Dashboard Preview */}
      <section id="dashboard-preview">
        <DashboardPreview />
      </section>
      
      {/* FAQ Section */}
      <section id="faq">
        <FAQSection />
      </section>
      
      {/* Final CTA */}
      {/* <section id="cta">
        <CTASection />
      </section> */}
      
      {/* Our Story */}
      <OurStorySection />
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;